import { WcsUser } from './wcs/user'
import { SCARCITY } from '@/scripts/constants/promos'
import { WcsPromotions } from './wcs/promotions'
import RbDate from '@/utils/rb-date'

const formatDay = (numberOfDays, dayLabel, daysLabel) => {
  const sanitizedDayLabel = numberOfDays === 1 ? dayLabel : daysLabel
  return numberOfDays > 0 ? `${numberOfDays} ${sanitizedDayLabel} ` : ''
}

const formatTimePart = (number) => {
  return number < 10 ? `0${number}` : number.toString()
}

export const formatTime = (time, dayLabel, daysLabel) => {
  const days = Math.floor(time / (1000 * 60 * 60 * 24))
  const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((time % (1000 * 60)) / 1000)

  return `${formatDay(days, dayLabel, daysLabel)}${formatTimePart(hours)}:${formatTimePart(
    minutes
  )}:${formatTimePart(seconds)}`
}

export const formatTimeTile = (time) => {
  const days = Math.floor(time / (1000 * 60 * 60 * 24))
  const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((time % (1000 * 60)) / 1000)
  if (days > 0) {
    return `${days}D:${formatTimePart(hours)}H:${formatTimePart(minutes)}M:${formatTimePart(
      seconds
    )}S`
  }
  return `${formatTimePart(hours)}H:${formatTimePart(minutes)}M:${formatTimePart(seconds)}S`
}

const formatAndSanitizePromotion = ({ startDate, endDate, price, priority, ...rest }, index) => {
  startDate = RbDate.getTimeDate(new Date(WcsPromotions.sanitizeDate(startDate)))
  endDate = RbDate.getTimeDate(new Date(WcsPromotions.sanitizeDate(endDate)))
  return {
    promoId: `promo-${index}`,
    startDate,
    endDate,
    price: parseFloat(price),
    priority: parseInt(priority),
    ...rest,
  }
}

const filterAndSortPromotions = (promotions, bypassUserSegmentFilter = false) => {
  const currentDate = RbDate.getTimeDate()
  const userCluster = WcsUser.getMergedUserCluster()
  return promotions
    .filter((promo) => promo.endDate > currentDate)
    .filter((promo) => {
      if (bypassUserSegmentFilter) {
        return true
      }
      return (
        !promo?.userSegments ||
        promo.userSegments.length === 0 ||
        userCluster?.some((cluster) => promo?.userSegments.includes(cluster))
      )
    })
    .sort((a, b) => {
      if (a.startDate < currentDate && b.startDate < currentDate) {
        if (!!a.userSegments && !!b.userSegments) {
          if (a.priority - b.priority > 0) {
            return -1
          }
          if (a.priority - b.priority < 0) {
            return 1
          }

          if (a.price - b.price > 0) {
            return 1
          }
          if (a.price - b.price < 0) {
            return -1
          }
        }
        if (a.priority - b.priority > 0) {
          return -1
        }

        if (a.priority - b.priority < 0) {
          return 1
        }

        if (a.userSegments) {
          return -1
        }

        if (b.userSegments) {
          return 1
        }

        if (a.price - b.price > 0) {
          return 1
        }

        if (a.price - b.price < 0) {
          return -1
        }
      }

      if (a.startDate - b.startDate > 0) {
        return 1
      }
      if (a.startDate - b.startDate < 0) {
        return -1
      }

      if (!!a.userSegments && !!b.userSegments) {
        if (a.priority - b.priority > 0) {
          return -1
        }
        if (a.priority - b.priority < 0) {
          return 1
        }

        if (a.price - b.price > 0) {
          return 1
        }
        if (a.price - b.price < 0) {
          return -1
        }
      }
      if (a.userSegments) {
        return -1
      }

      if (b.userSegments) {
        return 1
      }

      if (a.priority - b.priority > 0) {
        return -1
      }
      if (a.priority - b.priority < 0) {
        return 1
      }

      if (a.price - b.price > 0) {
        return 1
      }
      if (a.price - b.price < 0) {
        return -1
      }
      return a.endDate - b.endDate
    })
}

// TODO: change name
export const sortPromos = (promotions, bypassUserSegmentFilter = false) => {
  if (!promotions || !Array.isArray(promotions) || promotions.length === 0) {
    return []
  }
  const formattedPromotions = promotions.map(formatAndSanitizePromotion)
  return filterAndSortPromotions(formattedPromotions, bypassUserSegmentFilter)
}

// TODO: change name and improve this function
export const getBestBetweenTwoPromos = (priceArray) => {
  if (!priceArray || !Array.isArray(priceArray) || priceArray.length === 0) {
    return null
  }

  const currentPromo = priceArray.shift()

  if (priceArray.length > 1) {
    const nextPromo = priceArray[0]

    // Early Access is better, but i have to check also the price
    const hasNextPromoStarted = nextPromo.startDate < RbDate.getTimeDate()
    const isNextPromoTypeBetter =
      nextPromo.type === SCARCITY && currentPromo.type !== nextPromo.type
    const isNextPromoEarlyAccess = !currentPromo.userSegments && nextPromo.userSegments
    const hasNextPromoHigherPriority = nextPromo.priority > currentPromo.priority
    const hasNextPromoHigherDiscount = nextPromo.price < currentPromo.price

    if (
      hasNextPromoStarted &&
      (isNextPromoTypeBetter ||
        (isNextPromoEarlyAccess && hasNextPromoHigherDiscount) ||
        hasNextPromoHigherPriority ||
        (!hasNextPromoHigherPriority && hasNextPromoHigherDiscount))
    ) {
      return nextPromo
    }
  }

  return currentPromo
}
